<template>
  <div class="grid grid-cols-8 items-center gap-4">
    <Label :for="id" class="col-span-2 text-right"> {{ label }} </Label>
    <NumberField
      :id="id"
      v-model:modelValue="value"
      :min="min"
      :max="max"
      :disabled="disabled"
      @update:model-value="handleChange"
      class="col-span-5"
    >
      <NumberFieldContent>
        <NumberFieldDecrement />
        <NumberFieldInput />
        <NumberFieldIncrement />
      </NumberFieldContent>
    </NumberField>
    <div class="col-span-1 -ml-2 flex items-center justify-center">
      <slot></slot>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { Label } from '~/components/ui/label';
import {
  NumberField,
  NumberFieldContent,
  NumberFieldDecrement,
  NumberFieldIncrement,
  NumberFieldInput,
} from '~/components/ui/number-field';

const value = defineModel<number>({ required: true });
defineProps({
  id: String,
  label: String,
  min: {
    type: Number,
    default: 1,
  },
  max: {
    type: Number,
    default: 9,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(['handleChange']);
const handleChange = (val: number) => {
  emit('handleChange', val);
};
</script>
